const AUTH_TOKEN_KEY = "authToken";
const CSRF_TOKEN_KEY = "csrfToken";

export const clearAuthToken = () => {
  try {
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
    sessionStorage.removeItem(CSRF_TOKEN_KEY);
  } catch (err) {
    console.log("auth token clear error");
  }
};

export const getAuthToken = () => {
  try {
    return sessionStorage.getItem(AUTH_TOKEN_KEY) || "";
  } catch (err) {
    return "";
  }
};

export const setAuthToken = (token) => {
  if (!token) {
    return;
  }

  try {
    sessionStorage.setItem(AUTH_TOKEN_KEY, token);
  } catch (err) {
    console.log("auth token storage error");
  }
};

const getCsrfToken = () => {
  try {
    return sessionStorage.getItem(CSRF_TOKEN_KEY) || "";
  } catch (err) {
    return "";
  }
};

const setCsrfToken = (token) => {
  if (!token) {
    return;
  }

  try {
    sessionStorage.setItem(CSRF_TOKEN_KEY, token);
  } catch (err) {
    console.log("csrf token storage error");
  }
};

export const withAuth = (options = {}) => {
  const headers = {
    ...(options.headers || {}),
  };
  const token = getAuthToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {
    ...options,
    credentials: "include",
    headers,
  };
};

const needsCsrf = (method = "GET") =>
  !["GET", "HEAD", "OPTIONS"].includes(method.toUpperCase());

const fetchCsrfToken = async (url) => {
  const csrfUrl = new URL("/auth/csrf-token", url).toString();
  const token = getAuthToken();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await fetch(csrfUrl, {
    method: "GET",
    credentials: "include",
    headers,
  });

  if (!response.ok) {
    throw new Error("csrf fetch failed");
  }

  const data = await response.json();
  setCsrfToken(data.csrfToken);
  return data.csrfToken;
};

export const authFetch = async (url, options = {}) => {
  const requestOptions = withAuth(options);
  const method = (requestOptions.method || "GET").toUpperCase();

  if (needsCsrf(method)) {
    const csrfToken = getCsrfToken() || (await fetchCsrfToken(url));
    requestOptions.headers = {
      ...requestOptions.headers,
      "X-CSRF-Token": csrfToken,
    };
  }

  return fetch(url, requestOptions);
};
